<template>
  <div class="h-full">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">Menu</h2>
    </div>
    <div class="bg-white p-6 fixed-top"><UsermanagementList /></div>
  </div>
</template>
<script>
import UsermanagementList from "./components/UsermanagementList.vue";
export default {
  components: {
    UsermanagementList,
  },
};
</script>
